import vuei18n from '@/plugins/vue-i18n';
const sanitizeEndpointError = (error) => {
  console.error(error)
  if(error){    
    if(error.response){
      if(error.response.data){
        if(error.response.data.message){
          return error.response.data.message
        }
        if(error.response.data.error_description){
          return error.response.data.error_description
        }
      }
    }
    if(error.message){
      if(error.message === 'GENERAL'){
        return vuei18n.t("globalErrorUnknown");
      }else{
        if(error.stack){
          if(error.stack.includes('TypeError:')){
            return vuei18n.t("globalErrorUnknown");
          }
        }
        return error.message
      }
    }
    if(error.error){
      return error.error
    }

  }

  return vuei18n.t("globalErrorUnknown");
}

export {
  sanitizeEndpointError
}